import { IMenuAccess, IMenuDefinition } from "interfaces";
import strings from "strings";
import { isShortcodeEnabledForNBFleetDashboard } from "tools/helper";

const menus: IMenuDefinition[] = [
  { name: strings.MENU.FLEET_REPORTING, url: strings.ROUTES.FLEET_REPORTING, canViewMenu: () => true },
  { name: strings.MENU.ACCOUNTS,        url: strings.ROUTES.ACCOUNTS,        canViewMenu: () => true },
  { name: strings.MENU.EVENTS_FEED,     url: strings.ROUTES.EVENTS_FEED,     canViewMenu: () => isShortcodeEnabledForNBFleetDashboard() },
  { name: strings.MENU.PROFILE,         url: strings.ROUTES.PROFILE,         canViewMenu: () => true },
]

const getCarrierMenuAccess = (): IMenuAccess[] => {
  const menuList: IMenuAccess[] = menus
    .filter(menu => menu.canViewMenu())
    .map(({ name, url }) => ({ name, url }))

  menuList.push({ name: strings.MENU.HELP })

  return menuList
}

export default getCarrierMenuAccess
